// @flow

import React from "react";
import ReactDOM from "react-dom";

import QuickExitRibbon from "../components/QuickExitRibbon";

const el = document.querySelector("[data-quick-exit-ribbon]");
if (el) {
    const title = el.getAttribute("data-title") || "";
    const description = el.getAttribute("data-description") || "";
    const url = el.getAttribute("data-url") || "";
    const ribbonRoot = document.createElement("div");
    if (document && document.body) document.body.appendChild(ribbonRoot);

    el.onclick = function() {
        window.open(url, "_blank");
        window.location.replace(url);
    };
}
